(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/contextual-menu.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/contextual-menu.js');
"use strict";


const {
  ReactItemsMenu,
  ReactIcon
} = svs.ui;
const {
  ItemsMenu,
  BallItem
} = ReactItemsMenu;
class ContextMenu extends React.Component {
  renderXperten() {
    const {
      isOpenXperten,
      drawNumber
    } = this.props;
    if (!isOpenXperten) {
      return null;
    }
    return React.createElement(svs.challenge.Xperten, {
      drawNumber: drawNumber,
      modalHeaderClass: "challenge-modal-header"
    });
  }
  renderTipsInfo() {
    const {
      isOpenTipsinfo
    } = this.props;
    if (!isOpenTipsinfo) {
      return null;
    }
    return React.createElement(svs.challenge.Tipsinfo, {
      modalHeaderClass: "challenge-modal-header"
    });
  }
  renderGameGuide() {
    const {
      isOpenSpelguide,
      closeSpelguide
    } = this.props;
    if (!isOpenSpelguide) {
      return null;
    }
    return React.createElement(svs.components.gameguide.ReactGameguide, {
      closeSpelguide: closeSpelguide,
      gameGuides: svs.challenge.data.config.gameGuide.guides,
      modalHeaderClass: "challenge-modal-header",
      product: svs.challenge.constants.PRODUCT_NAME
    });
  }
  render() {
    const {
      openXperten,
      openTipsinfo,
      openSpelguide
    } = this.props;
    return React.createElement(React.Fragment, null, React.createElement(ItemsMenu, {
      branding: "challenge"
    }, React.createElement(BallItem, {
      borderOnly: true,
      label: "PIX!",
      onClick: () => {
        openXperten(true);
      }
    }, React.createElement(ReactIcon, {
      icon: "pix"
    })), React.createElement(BallItem, {
      borderOnly: true,
      label: "Tipsinfo",
      onClick: () => {
        openTipsinfo(true);
      }
    }, React.createElement(ReactIcon, {
      icon: "tipsinfo"
    })), React.createElement(BallItem, {
      borderOnly: true,
      label: "Spelguide",
      onClick: () => {
        openSpelguide(true);
      }
    }, React.createElement(ReactIcon, {
      icon: "tips"
    }))), this.renderXperten(), this.renderTipsInfo(), this.renderGameGuide());
  }
}
const mapStateToProps = state => ({
  isOpenSpelguide: state.openSpelguide,
  isOpenTipsinfo: state.openTipsinfo,
  isOpenXperten: state.openXperten
});
const {
  openXperten,
  openTipsinfo,
  openSpelguide,
  closeSpelguide
} = svs.challenge.actions;
svs.challenge.ContextMenu = ReactRedux.connect(mapStateToProps, {
  closeSpelguide,
  openSpelguide,
  openTipsinfo,
  openXperten
})(ContextMenu);

 })(window);